const es = {
    demo: {
        title: `Inglés`,
        introduction: `Lorem Ipsum`,
    },
    docs: {
        hi: `Hola`,
        description: `¿Necesita ayuda? \n Por favor, consulte nuestra documentación.`,
        documentation: `documentación`,
    },
    yes: `Sí`,
    no: `No`,
    home: `Inicio`,
    dashboard: `Panel de control`,
    user: `Usuario`,
    account: `Cuenta`,
    general: `General`,
    settings: `Configuraciones`,
    username: `Nombre de usuario`,
    login: `Iniciar sesión`,
    logout: `Cerrar sesión`,
    emailAddress: `Dirección de correo electrónico`,
    password: `Contraseña`,
    newPassword: `Nueva contraseña`,
    oldPassword: `Contraseña antigua`,
    confirmNewPassword: `Confirmar nueva contraseña`,
    updatePassword: `Actualizar contraseña`,
    formErrorValidEmail: `El correo electrónico debe ser una dirección de correo válida`,
    formErrorEmailRequired: `El correo electrónico es requerido`,
    formErrorPasswordRequired: `La contraseña es requerida`,
    formErrorOldPasswordRequired: `La contraseña antigua es requerida`,
    formErrorPasswordLength: `La contraseña debe tener al menos 6 caracteres`,
    formErrorConfirmPasswordRequired: `La confirmación de contraseña es requerida`,
    formErrorPasswordsMatch: `Las contraseñas deben coincidir`,
    formForgotPasswordLink: `¿Olvidó la contraseña?`,
    snackBarChangePasswordSuccess: `¡Cambio de contraseña exitoso!`,
    snackBarUpdateSuccess: `¡Actualización exitosa!`,
    active: `Activo`,
    inactive: `Inactivo`,
    on: `Encendido`,
    off: `Apagado`,
    billing: `Facturación`,
    description: `Descripción`,
    amount: `Cantidad`,
    status: `Estado`,
    changePassword: `Cambiar contraseña`,
    changeSettings: `Cambiar configuraciones`,
    setup: `Configuración`,
    free: `Gratis`,
    invoices: `Facturas`,
    cancelSubscriptionButton: `Cancelar suscripción`,
    date: 'Fecha',
    download: 'Descargar',
    print: 'Imprimir',
    close: 'Cerrar',
    view: 'Ver',
    DataOwl: `Data Owl`,
    DataOwlTip: `Data Owl escanea fuentes web ocultas para detectar si tu correo electrónico aparece en filtraciones de datos, ayudándote a mantenerte seguro con alertas oportunas.`,
    warningBanner: {
        text: 'No tiene una cuenta activa. Para activar su cuenta, renueve haciendo clic en el botón.',
        ctaButton: 'Renovar',
        caption: 'Subtítulo'
    },
    loginPage: {
        title: `Iniciar sesión`,
        formTitle: `¿Nuevo en Anomica? Crear cuenta`,
        formTitleLink: `aquí`,
        formForgotPasswordLink: `¿Olvidó la contraseña?`
    },
    resetPasswordPage: {
        title: `Restablecer contraseña`,
        formTitle: `¿Olvidó la contraseña?`,
        formSubTitle: ` Por favor, ingrese la dirección de correo electrónico asociada con su cuenta y le enviaremos un enlace para restablecer su contraseña por correo electrónico.`,
        formTitleLink: `Volver al inicio de sesión`,
        formButton: `Enviar solicitud`,
    },
    newPasswordPage: {
        title: `Restablecer contraseña`,
        formTitle: `¡Solicitud enviada con éxito!`,
        formSubTitle: `Hemos enviado un correo electrónico con un enlace de confirmación.`,
        formSubTitle2: `Por favor, visite el enlace para verificar su correo electrónico.`,
        formTitleLink: `Volver al inicio de sesión`,
        formButton: `Enviar solicitud`,
    },
    accountPage: {
        title: `Cuenta`,
        accountStatus: `Estado de la cuenta`,
        accountType: `Tipo de cuenta`,
        renewAccount: `Renovar cuenta`,
        endDate: `Fecha de finalización`,
        subRemaining: `Suscripción restante:`,
        autoRenew: `La renovación automática está`,
        vpnCredentials: `Credenciales VPN:`,
        setupVpn: `Configurar VPN`,
        nextBillingDate: `Próxima fecha de facturación`,
        endOfFreeTerm: `Fin del período gratuito`,
        cancelSubscription: `Cancelar suscripción`,
        activationCode: `Código de activación`,
        newsNotifications: `Correos electrónicos de noticias y notificaciones`,
        darkWebMonitoring: `Escudo Dark Web`,
        setupMonitoring: `Configurar monitoreo`,
        recurringSubscription: `Suscripción recurrente`,
        getSubscription: 'Obtener suscripción',
        nextBillingDateWarning: 'La fecha exacta de cargo puede variar y depende del método de pago.',
        tabs: {
            general: `General`,
            settings: `Configuraciones`,
            changePassword: `Cambiar contraseña`
        },
    },
    settingsPage: {
        title: `Configuraciones`,
        formTitle: `NOTIFICACIONES Y BOLETINES`,
        recurringPayment: ` Pago recurrente`,
        yourSubscription: `Su suscripción`,
        per: `Por`,
        curSubs: `La suscripción actual continuará hasta`,
        warn: `Su cuenta ya no se extenderá mensualmente.`,
        submitButton: `Guardar cambios`,
        settingsOption1: `Noticias y anuncios`
    },
    setupVpnPage: {
        title: `Configurar VPN`,
        header: `Descargar VPN Países Bajos para {{os}}`,
        coverH1: `Descargue la aplicación con un solo botón`,
        coverH2: `Solo necesita descargar, todo está completado para usted`,
        coverH3: `También disponible para`,
        coverButtonText: 'Descargar para ',
        setupBadge: `CONFIGURAR ANOMICA`,
        preferManual: `¿Prefiere instalarlo manualmente? Consulte los pasos a continuación.`,
        installManuallyLink: `Instalar manualmente`,
        footerText: `Si todavía tiene alguna pregunta, contáctenos en`,
        tabH1: `El código de activación ya está completado para usted y solo necesita descargar VPN Países Bajos.`,
        tabH2: `¿Prefiere instalarlo manualmente?`,
        step1: ` Descargar`,
        step1Caption: `El código de activación ya está completado para usted y solo necesita descargar VPN Países Bajos. ¿Prefiere instalarlo manualmente?`,
        step2: ` Copiar`,
        step2Caption: `Copie el código de activación y úselo durante la configuración del software.`,
        step3: ` Pegar`,
        step3Caption: `Pegue el código de activación copiado en el software para completar la instalación de VPN Países Bajos.`,
        manual: {
          disabledTooltip: `Disponible solo para usuarios autorizados con una suscripción activa.`,
          authRequired: `Por favor, inicia sesión para continuar.`,
          step1: `Elige un servidor`,
          step1Caption: `Selecciona un país y un servidor al que conectarte.`,
          country: `País`,
          server: `Servidor`,
          protocol: `Protocolo`,
          step2: `Descargar archivo de configuración`,
          step2Caption: `Descarga el archivo de configuración .ovpn para el servidor seleccionado.`,
          downloadButton: `Descargar .ovpn`,
          step3: `Conectar`,
          step3Caption: `Abre el cliente OpenVPN, importa el archivo descargado y conéctate. Usa el Login VPN y la Contraseña VPN indicados a continuación.`,
        },
    },
    promoPage: {

        tabH1: `¡Felicidades y bienvenido!. Su límite de tráfico ha sido actualizado. Disfrute de 5 GB de uso mensual. `,
        tabH2: `Solo necesita descargar, todo está completado para usted`,
    },
    cancelSubscription: {
        h1: `Si desea cancelar su suscripción, `,
        h1br:`puede hacerlo fácilmente a continuación.`,
        sub1: `Nos alegra haberlo tenido como miembro. Siempre es bienvenido a regresar.`,
        sub1br: `Puede completar su cancelación a continuación.`,
        cardTitle: `Cancelar suscripción`,
        cardText: `¿Está seguro de que quiere renunciar a su privacidad en línea? Entonces use el botón a continuación para completar la cancelación de su suscripción.`,
        cancelButton: `Completar cancelación`,
        backButton: `Volver al sitio web`,
        cardCaption: `La cancelación entrará en vigor al final de su período de facturación actual`,
        cardCaptionBr: `el`,
        h2: `¿Por qué quedarse con VPN Países Bajos?`,
        p1: `100% Privacidad`,
        p1c: `Con Anomica, todas las preocupaciones sobre su privacidad en línea son cosa del pasado. Nadie puede ver sus datos y puede moverse libremente en línea.`,
        p2: `100% Seguridad`,
        p2c: `Porque una VPN encripta su conexión, ya no es posible que los hackers irrumpan. Esto evitará que se vayan con sus datos.`,
        p3: `100% Libertad`,
        p3c: `Con Anomica, puede eludir los bloques geográficos y fingir que está en otro país, para disfrutar del 100% de libertad en línea.`,
        p4: `100% Streaming`,
        p4c: `Con Anomica, obtiene acceso a cada servicio de streaming (extranjero). Ventaja adicional: ¡Nuestras conexiones súper rápidas son perfectas para streaming!`,
        p5: `100% Descarga`,
        p5c: `Con los servidores súper rápidos y protocolos modernos de VPN Países Bajos, puede descargar y transmitir sin esfuerzo en cualquier lugar del mundo.`,
        exButton: `Mantenerse seguro en línea`,
        h1Canceled: `Ha cancelado su suscripción con éxito.`,
        h1CanceledFree: `Ha cancelado su suscripción con éxito.`,
        sub1Canceled: `Gracias por ser miembro, ¡vuelva cuando quiera!`,
        sure: `¿Está seguro?`,
        happy: `Estaremos encantados de verlo de vuelta en cualquier momento.`
    },
    verifyEmailPage: {
        title: ``,
        checkYourEmail: `¡Por favor, revise su correo electrónico!`,
        inProgress: `Verificación en progreso...`,
        bottomText: `Toda la información sobre su suscripción y la aplicación se encuentra en su bandeja de entrada.`,
        success: `¡Correo electrónico verificado!`,
        alreadyVerified: '¡Correo electrónico ya verificado!',
        button: `Ver su cuenta`,
        p1: `Ha elegido VPN Países Bajos`,
        p2: `Se ha registrado con éxito`,
        p3: `Su dirección de correo electrónico ha sido verificada con éxito`,
        p4: `Su suscripción a VPN Países Bajos ha sido activada.`,
    },
    billingPage: {

        paymentFor: `Pago por`,
        invoiceNumber: `ID de factura`,
    },
    monitoringPage: {
      title: `Data Owl`,
      setUpMonitoring: `Configurar monitoreo`,
      featureActivatedAlert: `Data Owl está ahora activado`,
      featureNotActivatedAlert: `Data Owl no está activado actualmente`,
      notifyToggleLabel: `Notificarme cuando se detecte una nueva filtración de datos`,
      consentDisclaimer: `Al activar esta función, aceptas que compartamos tu dirección de correo electrónico con servicios de escaneo seguros para comprobar si hay filtraciones de datos. Recibirás una notificación por correo electrónico cuando se descubran nuevas filtraciones.`,
      breachesDetectedTitle: `Filtraciones de datos detectadas`,
      breachesFoundWarning: `¡Oh no! Hemos encontrado <0>{{number}} {{breachWord}}</0>, incluyendo contraseñas filtradas. Lee <1>nuestro artículo</1> para saber cómo protegerte de futuras filtraciones.`,
      breach_one: `filtración de datos`,
      breach_other: `filtraciones de datos`,
      btnUpdating: `Actualizando...`,
      btnSaveAndScan: `Guardar cambios y escanear ahora`,
      btnSave: `Guardar cambios`,
      btnAddedToQueue: `Añadido a la cola...`,
      btnDataRetrieved: `Datos recuperados`,
      compromisedData: `Datos filtrados:`,
      dataOwl: {
        faq: {
          what_does_it_do: {
            heading: `¿Qué hace esta función?`,
            detail: `La herramienta Data Owl escanea continuamente la Dark Web y las bases de datos filtradas conocidas en busca de las direcciones de correo electrónico que eliges monitorear. Si tus datos se encuentran en una filtración, recibirás una alerta instantánea con detalles sobre la fuente y fecha de la filtración, qué información fue expuesta y otra información relevante. También recibirás guías claras sobre cómo proteger tus cuentas.`,
          },
          how_does_it_work: {
            heading: `¿Cómo me ayuda esta herramienta a protegerme?`,
            detail: `Las filtraciones de datos y las brechas de seguridad ocurren todos los días y representan una grave amenaza para tu seguridad en línea. Una vez que tus datos son filtrados, pueden usarse inmediatamente para todo tipo de ciberataques: desde phishing y estafas en línea hasta apropiación de cuentas y fraude financiero. Data Owl de Anomica te ayuda a ir un paso por delante notificándote en el momento en que ocurre una filtración, proporcionando informes detallados y ofreciendo orientación profesional para gestionar cada situación.`,
          },
          does_it_solve_anything: {
            heading: `¿Es gratis usar esta función?`,
            detail: `La herramienta Data Owl está incluida en cada suscripción de Anomica sin coste adicional. Ofrece monitoreo 24/7, seguimiento ilimitado de correos electrónicos, informes detallados de filtraciones y orientación personalizada para ayudarte a responder a cualquier incidente.`,
          },
        },
      },
      dataClasses: {
        "Email addresses": `Direcciones de correo electrónico`,
        Passwords: `Contraseñas`,
        Usernames: `Nombres de usuario`,
        "IP addresses": `Direcciones IP`,
        "Physical addresses": `Direcciones físicas`,
        "Phone numbers": `Números de teléfono`,
        Names: `Nombres`,
        "Job titles": `Cargos`,
        "Dates of birth": `Fechas de nacimiento`,
        "Financial data": `Datos financieros`,
        "Credit cards": `Tarjetas de crédito`,
        "Bank account numbers": `Números de cuenta bancaria`,
        "Social security numbers": `Números de seguridad social`,
        "Historical passwords": `Contraseñas antiguas`,
      },
    },
    invoiceDetailsPage: {
        title: `Factura`,
        email: 'Correo electrónico',
        customerNumber: 'Número de cliente',
        invoiceFrom: 'Factura de',
        invoiceTo: 'Factura a',
        invoiceDate: 'Fecha de factura',
        invoicePaymentMethod: 'Método de pago',
        invoiceDescription: 'Descripción',
        invoiceProductQty: 'Cant.',
        invoiceProductPrice: 'Precio',
        invoiceTotal: 'Total',
        invoiceSubtotal: 'Subtotal',
        invoiceVat: 'Impuestos (IVA)',
        supportDescription: '¿Tiene una pregunta?',
        status: {
            open: 'Abierto',
            paid: 'pagado',
            canceled: 'cancelado',
            pending: 'pendiente',
            chargeback: 'reembolso',
            expired: 'expirado',
            failed: 'fallido',
            settled: 'liquidado',
            partially_refunded: 'parcialmente reembolsado',
            refunded: 'reembolsado',
            authorized: 'autorizado',
            internal_error: 'error interno',
        }
    },
    maintenancePage: {

        h1: `Estamos realizando mantenimiento.`,
        h2: `¡Volvemos enseguida!`,
    },
    page404: {
        h1: `Ups… la página que buscas no existe.`,
        p: `¿Te perdiste durante tu búsqueda del proveedor Anomica? ¡No te preocupes, te llevamos allí!`,
        btn: `¡Llévame al mejor VPN!`,
    }
};

export default es;
